<script setup>
import BaseIcon from "@/app/components/ui/BaseIcon.vue"

import { t } from "@/app/composables/useI18n"
import Manage2FA from "@/user-account/components/security/Manage2FA.vue"
import { computed } from "vue"
import KYCLevels from "./KYCLevels.vue"
import LoginInfo from "./LoginInfo.vue"
import coolOff from "./coolOff.vue"
import selfExclusion from "./selfExclusion.vue"
import SessionLimits from "./SessionLimits.vue"
import { useBetStore } from "/store"

const _props = defineProps({
  show: Boolean,
})

const _emit = defineEmits(["close"])

const DEV_ENV = import.meta.env.VITE_APP_ENV === "development"

const store = useBetStore()

const tabs = computed(() => {
  const baseTabs = [
    { value: "loginInfo", title: "login_info", icon: "edit-info" },
    { value: "kyc", title: "kyc", icon: "kyc" },
    { value: "limits", title: "responsible_gambling", icon: "limits" },
    { value: "2fa", title: "2fa_add", icon: "limits" },
  ]

  return baseTabs
})

function onTabClick(tab) {
  store.setAccountTab(tab)
}

const selectedTab = computed(() => {
  return store.getAccountTab
})
</script>

<template>
  <div class="account-details">
    <div class="account-details__options">
      <div
        v-for="(tab, i) in tabs"
        :key="i"
        :class="`btn ${selectedTab === tab.value && 'active-btn'}`"
        @click="onTabClick(tab.value)"
      >
        <BaseIcon
          :name="tab.icon"
          size="17"
          :color="
            selectedTab === tab.value
              ? 'var(--be-primary-btn-text-label)'
              : 'var( --be-primary-text-color-opacity)'
          "
        />

        <div>{{ t(`general.${tab.title}`) }}</div>
      </div>
    </div>
    <div v-if="selectedTab === 'loginInfo'">
      <LoginInfo />
    </div>
    <div v-if="selectedTab === 'kyc'">
      <KYCLevels />
    </div>
    <div v-if="selectedTab === 'limits'">
      <coolOff />
      <SessionLimits />
      <selfExclusion />
    </div>

    <div v-if="selectedTab === '2fa'">
      <Manage2FA />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.account-details {
  border-radius: 8px;
  margin: 0 16px;

  .account-details__options {
    background: var(--be-big-card-bg);
    border-radius: 8px;
    display: flex;
    padding: 10px;
    justify-content: space-between;
    font-size: 12px;
    margin-bottom: 1rem;
    .btn {
      color: rgba(255, 255, 255, 0.3);
      display: flex;
      flex-direction: column;
      gap: 5px 0;
      align-items: center;
      justify-content: center;
      flex-grow: 1;
      cursor: pointer;
      width: 33%;
      padding: 9px 0;
      text-align: center;
    }
    .active-btn {
      border-radius: 6px;
      color: var(--be-primary-btn-label);
      background: var(--be-primary-btn);
      box-shadow: 0px 0px 10px 0px rgba(116, 62, 232, 0.5);
    }
  }
}
@media screen and (max-width: 550px) {
  .btn {
    font-size: 9px;
  }
}
</style>
